var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.927,
    height: 100.359,
    viewBox: "0 0 133.927 100.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49211",
    "data-name": "Path 49211",
    d: "M3886.066,1900.761c-16.245-28.136-21.9-24.492-32.26-32.26s-56.167,4.373-65.53-30.571S3753,1802.654,3753,1802.654v87.673s6.475,14.057,19.052,12.578,114.875,0,114.875,0Z",
    transform: "translate(-3753 -1802.654)",
    fill: "rgba(51,136,199,0.39)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBg);
export default __webpack_public_path__ + "static/media/card-bg.220db9724c2d0608bd50666475f9e042.svg";
export { ForwardRef as ReactComponent };